<template>
  <div style="background-color: white">
    <div id="shb" style="">
      <div id="header">
        <!-- <h4 id="denglu">首页</h4> -->
        <a tag="div" @click="goBack" id="goind">
          <!-- <img src="../../static/img/ind.png" alt=""> -->
        </a>
        <h3>趣美妆</h3>
        <!-- <h3 id="denglu"><router-link :to="{name:'Login',query:{is:'1'}}" tag="span">登录</router-link> | <router-link :to="{name:'Regis',query:{is:'2'}}" tag="span">注册</router-link></h3> -->
        <!-- <h4 id="denglu"><router-link :to="{name:'Login',query:{is:'1'}}" tag="span" style="color:#fff;">登录</router-link></h4>
        <h3 id="shangchuan"><router-link :to="{name:'Upload',query:{is:'1'}}" tag="span">上传</router-link></h3> -->
        <!--        <router-link :to="{name:'vip',query:{is:'1'}}" id="tomin" tag="div"></router-link>-->
        <span v-show="!isLogin" id="tomin" tag="div" @click="zhangh"></span>
        <div  v-show="isLogin"  id="user" class="user" tag="div" @click="userCenter">
          <img :src="headUrl" alt="" style="padding: 0;width:100%;height: 100%;">
        </div>
      </div>
<!--      <div id="nav" style="background:white;">-->
<!--        &lt;!&ndash; <div> &ndash;&gt;-->
<!--        &lt;!&ndash; <img src="../../static/img/247.png" style="width:100%;height:100%;" alt=""> &ndash;&gt;-->
<!--        &lt;!&ndash; </div> &ndash;&gt;-->
<!--      </div>-->
    </div>
<!--    <div id="null" style="width:100%;height:1.43rem;"></div>-->
    <div id="container">
      <!-- <div>
          <img id="banner" v-on:click="load(1)" src="" alt="">
      </div> -->
      <div>
        <div>
          <div class="home-banner swiper-slide">
            <div class="carousel-indicator">{{ this.c_index }}/{{ this.toti }}</div>
<!--            <el-carousel indicator-position="outside" :autoplay="false" ref="slideCarousel" height="4rem"-->
<!--                         @change="slideChange">-->
            <el-carousel :autoplay="false" ref="slideCarousel" height="4rem"
                           @change="slideChange">
              <el-carousel-item v-for="item in dataList" :key="item.id">
                <img class="banner" :src="item.src1" alt="">
              </el-carousel-item>
            </el-carousel>
          </div>

        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>
        <div :id="nav_id" style="overflow: hidden;">
          <div style="display: flex;">
            <!-- <img src="../../static/img/247.png" style="width:100%;height:100%;" alt=""> -->
          </div>
        </div>
      </div>

      <div
          style="padding: 0 .1rem;;height:.6rem;display:flex;justify-content:space-between;align-items:center;background:white;">
        <div style="display:flex;justify-content:space-between;align-items:center;">
          <div style="width:.403rem;height:.403rem;overflow:hidden;">
            <img class="headU" :src="authorHeadUrl" style="width:100%;border-radius:.403rem;" alt="">
          </div>
          <div style="font-size:.15rem;color:#494949;margin-left:.1rem;font-weight: bolder;" class="mingz">
            {{ authorName }}
          </div>

        </div>
        <button v-show="gzStatus === 0" type="button" class="b-button s outline color author-follow"
                @click="guanzhu(1)">
          <i class="b-button-outline"></i>
          <span class="b-button-text" id="gz_span">关注</span>
        </button>

        <button v-show="gzStatus === 1" type="button" class="b-button s outline color author-follow"
                @click="guanzhu(2)">
          <i class="b-button-outline" style="color: grey;"></i>
          <span class="b-button-text" id="ygz_span">已关注</span>
        </button>
      </div>

      <div class="content-container">
        <div>
          <div class="content-text">
            <div class="title">
              {{ this.title }}
            </div>
            <div class="content">
              {{ this.content }}
            </div>
          </div>
          <div class="publish-time-container">
            <div class="publish">
              发布于 {{ this.publishTime }}
            </div>
          </div>
        </div>
      </div>

      <div class="line_01"></div>

      <div class="comment" v-show="!fromWeather">
        <span class="total_comment">共 {{ this.totalCommentSize }} 条评论 </span>
        <div class="comment_detail">
          <div v-for="(item,p_index) in commentList" :key="item.id">
            <div class="comment_main">
              <div class="comment_head_image">
                <img class="headU" :src="item.headUrl" style="width:.35rem;border-radius:.35rem;" alt="">
              </div>
              <div class="comment_txt" @click="replyComment(item.id,-1,item.senderName,item.senderId)">
                <div class="comment_nickname">
                  {{ item.senderName }}
                  <el-badge value="作者" class="authorItem" v-if="item.replyByAuthor === 1" type="info"></el-badge>
                </div>
                <div class="comment_content">{{ item.content }} <span class="common_time">{{ item.sendTime }}</span>
                </div>
              </div>
              <div class="comment_xin"
                   @click="commentDz(item.id,item.currentUserLike === null || item.currentUserLike === 0 ? 1 : 2,item,p_index)">
                <div class="comment_xin_image">
                  <img v-show="item.currentUserLike === null || item.currentUserLike === 0"
                       src="../../static/img/kongxin2.png" style="width:.15rem;height:.13rem;margin-top:.1rem;" alt="">
                  <img v-show="item.currentUserLike === 1" src="../../static/img/shixin2.png"
                       style="width:.15rem;height:.13rem;margin-top:.1rem;" alt="">
                  <div class="comment_xin_num">
                    {{ item.totalLike }}
                  </div>
                </div>
              </div>
            </div>

            <div class="comment_sub_more sub" v-for="(subItem,index) in item.subCommentList" :key="subItem.id">
              <div class="comment_sub" v-show="index === 0 || item.show ">
                <div class="comment_sub_head_image">
                  <img class="headU" :src="subItem.headUrl" style="height:.25rem;width:.25rem;border-radius:.25rem;"
                       alt="">
                </div>
                <div class="comment_sub_txt" v-if="subItem.type === 2 "
                     @click="replyComment(item.id,subItem.id,subItem.senderName,subItem.senderId)">
                  <div class="comment_sub_nickname">
                    {{ subItem.senderName }}
                    <el-badge value="作者" class="authorItem" v-if="subItem.replyByAuthor === 1" type="info"></el-badge>
                  </div>
                  <div class="comment_sub_content">{{ subItem.content }} <span
                      class="common_time">{{ subItem.sendTime }}</span></div>
                </div>
                <div class="comment_sub_txt" v-if="subItem.type === 3 "
                     @click="replyComment(item.id,subItem.id,subItem.senderName,subItem.senderId)">
                  <div class="comment_sub_nickname">
                    {{ subItem.senderName }}
                    <el-badge value="作者" class="authorItem" v-if="subItem.replyByAuthor === 1" type="info"></el-badge>
                  </div>
                  <div class="comment_sub_content">
                    回复<span class="comment_sub_nickname">{{ subItem.replyName }}</span>：{{ subItem.content }} <span
                      class="common_time">{{ subItem.sendTime }}</span>
                  </div>
                </div>

                <div class="comment_sub_xin"
                     @click="subCommentDz(subItem.id,subItem.currentUserLike === null || subItem.currentUserLike === 0 ? 1 : 2,item,p_index,subItem,index)">
                  <div class="comment_sub_xin_image">
                    <img v-show="subItem.currentUserLike === null || subItem.currentUserLike === 0"
                         src="../../static/img/kongxin2.png" style="width:.15rem;height:.13rem;margin-top:.1rem;"
                         alt="">
                    <img v-show="subItem.currentUserLike === 1" src="../../static/img/shixin2.png"
                         style="width:.15rem;height:.13rem;margin-top:.1rem;" alt="">
                    <div class="comment_sub_xin_num">
                      {{ subItem.totalLike }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="comment_sub_more more">
              <div class="comment_more" v-show="item.subCommentList.length > 1 && !item.show"
                   @click="changeStatus(item,p_index)">
                展开 {{ item.subCommentList.length - 1 }} 条回复
              </div>
            </div>
            <div class="line_02"></div>

          </div>
        </div>
      </div>

      <div class="action-bar">
        <div class="action-input" @click="comment" v-show="!fromWeather">
          <i class="el-icon-edit"></i>
          <span class="barrage-txt">说点什么...</span>
        </div>
        <div class="action-text" v-show="fromWeather">
          <span class="barrage-txt">喜欢就点赞收藏吧～</span>
        </div>
        <div class="action-buttons" style="position:relative;">
          <div class="action-button" @click="dz(dzStatus === null || dzStatus === 0 ? 1 : 2)">
            <img v-show="dzStatus === null || dzStatus === 0" src="../../static/img/kongxin.png"
                 style="width:.15rem;height:.13rem;margin-bottom: .03rem;" alt="">
            <img v-show="dzStatus === 1" src="../../static/img/shixin.png"
                 style="width:.15rem;height:.13rem;margin-bottom: .03rem;" alt="">
            <strong>
              <span class="rf-n">{{ this.totalLike }}</span>
            </strong>
          </div>
          <div class="action-button" @click="collect(collectStatus === null || collectStatus === 0 ? 1 : 2)">
            <i v-show="collectStatus === null || collectStatus === 0" class="el-icon-star-off"></i>
            <i v-show="collectStatus  === 1" class="el-icon-star-on"></i>
            <strong>
              <span class="rf-n">{{ this.totalCollect }}</span>
            </strong>
          </div>
          <div class="action-button share-btn" @click="share">
            <i class="el-icon-share"></i>
            <strong class="rf-n">分享</strong>
          </div>
        </div>
      </div>

      <BizPageComponent :bizInfo="bizInfo" ref="bizPage"></BizPageComponent>

      <div :id="nav_bottom_id" style="margin-top:.1rem;margin-bottom:.1rem;overflow: hidden;">
        <div>
          <!-- <img src="../../static/img/247.png" style="width:100%;height:100%;" alt=""> -->
        </div>
      </div>

      <el-drawer
          :visible.sync="drawer"
          :show-close="false"
          direction="btt"
          :before-close="handleClose"
          size="10"
          :modal="false"
          :withHeader="false">
        <div class="float-comment"
             style="display: flex;justify-content: flex-start; margin-top: .15rem;margin-bottom: .15rem;">
          <div style="width:65%;margin-left: .1rem;" id="input_comment_div">
            <el-input
                ref="inputComment"
                type="textarea"
                :placeholder="sendInputHolder"
                v-model="sendComment"
                maxlength="50"
                autosize
                show-word-limit
                width="70%"
            >
            </el-input>
          </div>
          <div class="send_comment_button" style="margin-left: .3rem;margin: auto;">
            <el-button type="primary" round size="mini" @click="send" :disabled="sendLock">发送</el-button>
          </div>
        </div>
      </el-drawer>

      <el-drawer
          :visible.sync="select_drawer"
          :show-close="false"
          :before-close="handleClose"
          direction="btt"
          size="10"
          :modal="false"
          :withHeader="false">
        <div class="select-opt">
          <ul class="select-opt-ul">

            <li @click="showSenderInputForLi()">
              <div style="width: 100%;margin-top:.1rem;margin-bottom:.1rem;margin-left: 40%;">
                <i class="el-icon-edit"></i>
                回复
              </div>
            </li>
            <li @click="delComment()">
              <div style="width: 100%;margin-top:.1rem;margin-bottom:.1rem;margin-left: 40%;">
                <i class="el-icon-delete"></i>
                删除
              </div>
            </li>
          </ul>
        </div>
      </el-drawer>

      <div @click="Desk" style="position:fixed;bottom:0.4rem;right:0.1rem;width:.4rem;height:.4rem;opacity:.92;">
        <!-- 添加桌面 -->
        <img src="../../static/img/addsc.png" style="width:.4rem;height:.4rem;" alt="">
      </div>

    </div>

    <!-- <div id="biglove"></div> -->
    <div class="tishi" v-show="copyUrl">
      <div id="logo">
        <!-- <img src="../../static/img/qv_logo.png" alt=""> -->
      </div>
      <div style="position:fixed;width:2rem;">
        <p style="font-size:.14rem;margin-left: .03rem;">点击<span style="margin-left:.05rem;color:#d02121;border: 1px solid #d02121;border-radius:.05rem;" @click="copyHref">复制链接</span>
          然后“<span style="color:#d02121;">右上角</span>” 分享给好友吧～</p>
      </div>
    </div>

    <div  class="tishi" v-show="addDesk">
      <div id="logo2">
        <!-- <img src="../../static/img/qv_logo.png" alt=""> -->
      </div>
      <div style="position:fixed;width:2rem;">
        <p style="font-size:.12rem;margin-left: .03rem;">点击<img style="width: .1rem;margin: 0 .04rem;" src="../../static/img/sha.png" alt="">选择“<span
            style="color:#d02121;">添加书签</span>”,“<span style="color:#d02121;">添加桌面</span>”放至手机主屏。</p>
      </div>
    </div>

    <div id="foot">
      <p style="color:white;padding: 0 .1rem;">声明：本站提供的图片等资源素材来自投稿以及收集于互联网，如果侵犯了您的版权请来信告知，我们会及时处理和回复。</p>
      Copyright © 2022-2025 中广在线(北京)网络科技有限公司 All Rights Reserved.网站备案/许可证号:
      <a href="https://beian.miit.gov.cn" target="_blank" style="color:#fff;">京ICP备19011357号-3</a>
      <p style="text-align: center;">
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010602006775" style="color: #fff;">
          <img data-v-2d7e8ae2="" src="/static/img/BeianIcon.png" alt="" style="width: 24px; height: 24px;">
          京公网安备 11010602006775号
        </a>
      </p>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import Swiper from 'swiper';
import BizPageComponent from "../components/bizPage/BizPage";

export default {
  name: 'BeautyDetail',
  inject: ['reload'],
  data() {
    return {
      name:'BeautyDetail',
      img_id: '',
      img_id_new: 1,
      a: '',
      maskShow: false,
      copyUrl: false,
      addDesk:false,
      zan: false,
      dataList: [],
      timer: [],
      current: '',
      toti: '',
      lastId: '',
      nextId: '',
      book_huoqu: '',
      c_index: '1',
      title: '',
      content: '',
      publishTime: '',
      totalLike: 0,
      totalCollect: 0,
      commentList: [],
      totalCommentSize: 0,
      headUrl: '',
      userId: '',
      nickName: '',
      authorId: '',
      authorHeadUrl: '',
      authorName: '',
      gzStatus: '',
      noteId: '',
      dzStatus: '',
      collectStatus: '',
      dzLock: false,
      gzLock: false,
      collectLock: false,
      commentDzLock: false,
      actionTimes: 0,
      actionLastTime: 0,
      sendComment: '',
      drawer: false,
      select_drawer: false,
      sendLock: false,
      replyCommentId: '',
      replyId: '',
      sendInputHolder: '说点什么...',
      isLogin:false,
      fromWeather:true,
      bizInfo:{},
      nav_id:'_' + this.common.randomStringForId(Math.random() * 8 + 12),
      nav_bottom_id:'_' + this.common.randomStringForId(Math.random() * 8 + 12),
    }
  },
  components:{
    BizPageComponent
  },
  methods: {
    countAction() {
      let actionTime = new Date().getTime();
      if (actionTime - this.actionLastTime < 30 * 1000) {
        this.actionTimes++;
      } else {
        this.actionTimes = 0;
        this.actionLastTime = actionTime;
      }
      if (this.actionTimes > 10) {
        return false;
      }
      return true;
    },
    getCookie: function () {
      // Cookies.remove("book_huoqu");
      this.uuid = this.common.getUUID();
      this.userId = this.userTool.getUserId();
      this.headUrl = this.userTool.getUserHeadUrl();
      if (this.userId == undefined || this.userId == '') {
        this.gzStatus = 0;
        this.isLogin = false;
      } else {
        this.isLogin = true;
      }
    },
    changeStatus(item, p_index) {
      item.show = true,
          this.$set(this.commentList, p_index, item);
    },
    slideChange(target_index, src_index) {
      // console.log()
      this.c_index = target_index + 1;
    },
    // 滑动切换
    slideBanner() {
      //选中的轮播图
      var box = document.querySelector('.el-carousel__container');
      var startPointX = 0
      var stopPointX = 0

      var startPointY = 0
      var stopPointY = 0
      //重置坐标
      var resetPoint = function () {
        startPointX = 0
        stopPointX = 0
        startPointY = 0
        stopPointY = 0
      }
      //手指按下
      box.addEventListener("touchstart", function (e) {
        //手指点击位置的X坐标
        startPointX = e.changedTouches[0].pageX
        startPointY = e.changedTouches[0].pageY
      });
      //手指滑动
      box.addEventListener("touchmove", function (e) {
        //手指滑动后终点位置X的坐标
        stopPointX = e.changedTouches[0].pageX
        stopPointY = e.changedTouches[0].pageY
      });
      //当手指抬起的时候，判断图片滚动离左右的距离
      let that = this
      box.addEventListener("touchend", function (e) {
        if (stopPointX == 0 || startPointX - stopPointX == 0) {
          resetPoint()
          return
        }
        //上下大于左右
        if (Math.abs(startPointY - stopPointY) > Math.abs(startPointX - stopPointX)) {
          resetPoint()
          return;
        }
        if (startPointX - stopPointX > 20) {
          resetPoint()
          that.$refs.slideCarousel.next()
          return
        }
        if (startPointX - stopPointX < -20) {
          resetPoint()
          that.$refs.slideCarousel.prev()
          return
        }
      });
    },
    goind: function () {
      Cookies.remove('book_huoqu');
    },
    getData: function () {
      let key = 'Girliaefpqp!$TUJi^#@888';
      let t = new Date().getTime();
      let jiami = '';

      function encryptByDESModeEBC(message, key) {
        var keyHex = CryptoJS.enc.Utf8.parse(key);
        var encrypted = CryptoJS.DES.encrypt(message, keyHex, {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.ciphertext.toString();
      }

      var source = JSON.stringify({"userId": this.userId, "uuid": this.uuid, "noteId": this.a, "type": 2})
      // var source = JSON.stringify({"uuid":uuid,"albumId":this.a})
      var cc = encryptByDESModeEBC(CryptoJS.enc.Utf8.parse(source), key + "_" + t);
      jiami = cc;

      // console.log(uuid);
      // console.log(this.img_id);
      // console.log(source);
      let apiUrl = process.env.APP_API_URL;
      this.$http.get(apiUrl + "/note/detail?data=" + jiami + "&t=" + t
      ).then((res => {
            // console.log(res);
            if (res.body.data == null) {
              this.$toast.center('出错啦！');
              this.$router.push({path: '/meizhuang'});
            } else {
              this.commentList = [];
              // $(".headU").attr("src", res.body.data.headUrl);
              // $(".mingz").text(res.body.data.nickName);
              // $(".lik").text(res.body.data.totalLike);
              this.dataList.length = 0;
              this.timer.length = 0;
              let arr = res.body.data.imageList;
              this.toti = arr.length;
              this.title = res.body.data.title;
              this.content = res.body.data.content;
              this.publishTime = res.body.data.publishTime;
              this.totalLike = res.body.data.totalLike;
              this.totalCollect = res.body.data.totalCollect;
              this.totalCommentSize = res.body.data.totalCommentSize;
              this.authorId = res.body.data.authorId;
              this.noteId = res.body.data.id;
              this.authorHeadUrl = res.body.data.headUrl;
              this.authorName = res.body.data.nickName;
              if (res.body.data.gzAuthor != null) {
                this.gzStatus = res.body.data.gzAuthor === 0 ? 0 : 1;
              }
              this.dzStatus = res.body.data.like;
              this.collectStatus = res.body.data.collect;

              for (let i in arr) {
                this.dataList.push({
                  src1: arr[i],
                  id: i,
                })
              }

              this.commentList = res.body.data.commentList
              // // for(let index in )
              // this.$set()
              for (let j in arr) {
                var date = new Date(arr[j].publishTime * 1000);
                let Y = date.getFullYear() + '-';
                let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
                if (Y < 2019) {
                  this.timer.push({
                    tim: Y + M + D
                  })
                } else {
                  this.timer.push({
                    tim: M + D
                  })
                }

              }
              this.current = this.timer[0].tim;

              //判断是不是第一次获取
              var book_huoqu = Cookies.get("book_huoqu");
              // console.log(book_huoqu);
              if (book_huoqu == undefined) {
                Cookies.set('book_huoqu', arr[0].id);
                this.book_huoqu = book_huoqu;
              } else {
                this.book_huoqu = book_huoqu;
              }
              //展示商机
              let bizInfo = res.body.data.noteBizInfo;
              if(bizInfo){
                bizInfo.noteId = this.noteId;
                this.initBizInfo(bizInfo);
              }
            }
          }),
          (res => {

          })
      )
    },
    initBizInfo(bizInfo){
      if(bizInfo){
        this.bizInfo = bizInfo;
        this.$refs.bizPage.bizMonitor(bizInfo);
      }
    },
    getTempData: function () {
      let key = 'Girliaefpqp!$TUJi^#@888';
      let t = new Date().getTime();
      let jiami = '';

      function encryptByDESModeEBC(message, key) {
        var keyHex = CryptoJS.enc.Utf8.parse(key);
        var encrypted = CryptoJS.DES.encrypt(message, keyHex, {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.ciphertext.toString();
      }

      var source = JSON.stringify({"userId": this.userId, "uuid": this.uuid, "noteId": this.a, "type": 2})
      // var source = JSON.stringify({"uuid":uuid,"albumId":this.a})
      var cc = encryptByDESModeEBC(CryptoJS.enc.Utf8.parse(source), key + "_" + t);
      jiami = cc;

      // console.log(uuid);
      // console.log(this.img_id);
      // console.log(source);
      let apiUrl = process.env.APP_API_URL;
      this.$http.get(apiUrl + "/note/detail?data=" + jiami + "&t=" + t
      ).then((res => {
            // console.log(res);
            if (res.body.data == null) {
              this.$toast.center('出错啦！');
              this.$router.push({path: '/meizhuang'});
            } else {
              this.commentList = [];
              // $(".headU").attr("src", res.body.data.headUrl);
              // $(".mingz").text(res.body.data.nickName);
              // $(".lik").text(res.body.data.totalLike);
              // this.dataList.length = 0;
              this.timer.length = 0;
              let arr = res.body.data.imageList;
              this.toti = arr.length;
              this.title = res.body.data.title;
              this.content = res.body.data.content;
              this.publishTime = res.body.data.publishTime;
              this.totalLike = res.body.data.totalLike;
              this.totalCollect = res.body.data.totalCollect;
              this.totalCommentSize = res.body.data.totalCommentSize;
              this.authorId = res.body.data.authorId;
              this.noteId = res.body.data.id;
              this.authorHeadUrl = res.body.data.headUrl;
              this.authorName = res.body.data.nickName;
              if (res.body.data.gzAuthor != null) {
                this.gzStatus = res.body.data.gzAuthor === 0 ? 0 : 1;
              }
              this.dzStatus = res.body.data.like;
              this.collectStatus = res.body.data.collect;

              this.commentList = res.body.data.commentList
              // // for(let index in )
              // this.$set()
              for (let j in arr) {
                var date = new Date(arr[j].publishTime * 1000);
                let Y = date.getFullYear() + '-';
                let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
                if (Y < 2019) {
                  this.timer.push({
                    tim: Y + M + D
                  })
                } else {
                  this.timer.push({
                    tim: M + D
                  })
                }

              }
              this.current = this.timer[0].tim;
            }
          }),
          (res => {

          })
      )
    },
    load: function (a) {


      $("body").css("overflow", "auto");
      //每次点击图片让页面返回顶部，露出广告
      // $("body").animate({scrollTop:0},10);
      $("body").scrollTop(0);
      $(".mescroll-downwarp").attr("style", "display:none");
      $(".mescroll-upwarp").attr("style", "display:none");


      this.img_id = this.$route.query.id;

      if (a == 0) {
        this.a = this.img_id;
      } else if (a == 1) {
        // console.log(this.nextId);
        if (this.nextId != null) {
          this.a = this.nextId;
          this.$router.push({name: 'BeautyDetail', query: {id: this.a}});
          this.reload();
        } else {
          // this.$toast.center('没有啦！');
          this.a = this.book_huoqu;
          this.$router.push({name: 'BeautyDetail', query: {id: this.a}});
          this.reload();
        }
      } else if (a == 3) {
        if (this.lastId != null) {
          this.a = this.lastId;
          this.$router.push({name: 'BeautyDetail', query: {id: this.a}});
          this.reload();
        } else {
          this.$toast.center('没有上一组啦！');
          // this.a = 113;
          // this.$router.push({name:'BeautyDetail',query:{id:this.a}});
          // this.reload();
        }

      } else {
        this.a = this.a;
      }

      let that = this;

      setTimeout(function () {
        that.common.loadAd(406,that.nav_id);
        that.common.loadAd(407,that.nav_bottom_id);
      }, 600)

      // history.pushState(null, null, document.URL);
      // window.addEventListener('popstate', function () {
      //   history.pushState(null, null, document.URL);
      //   that.goBack();
      // });

      this.getData();
    },
    isad: function () {
      if ($('div[id=e_b_div_113]').length != 0) {
        // console.log(1);
        $("#null").css('display', "block");
        $("#container").css("margin-top", "0")
      } else {
        // console.log(0);
        $("#null").css('display', "none");

      }
    },
    Desk: function () {
      this.addDesk = !this.addDesk;
      let that = this;
      setTimeout(function () {
        that.addDesk = false;
      }, 2000)
    },
    copyHref:function (){
      let oInput = document.createElement("input");
      //这边为链接地址this.liveLink='www.baidu.com'
      oInput.value = window.location.href;
      document.body.appendChild(oInput);
      oInput.select();
      // console.log(oInput.value);
      document.execCommand("Copy");
      oInput.remove();
      this.$toast.center('复制成功！');
    },
    share: function () {
      this.copyUrl = !this.copyUrl;
      let that = this;
      setTimeout(function () {
        that.copyUrl = false;
      }, 5000)
    },
    userCenter: function () {
      let path = this.common.encodePath("BeautyDetail");
      this.$router.push({name: 'vip', query: {src: path, id: this.a}});
    },
    //账号登录
    zhangh: function () {
      let path = this.common.encodePath("BeautyDetail");
      this.$router.push({name: 'Login', query: {src: path, id: this.a}});
    },
    guanzhu: function (type) {
      if (!this.countAction()) {
        this.$toast.center('操作过于频繁，请稍候重试！');
        return;
      }
      if (this.gzLock) {
        return;
      }
      this.gzLock = true;
      if (this.userId == undefined || this.userId == '') {
        this.gzLock = false;
        this.zhangh();
      } else if (this.authorId != null && this.authorId.length > 0) {
        let params = {"userId": this.userId, "uuid": this.uuid, "authorId": this.authorId, "type": type}
        let t = new Date().getTime();
        let data = this.common.encodeParams(params, t);
        let apiUrl = process.env.APP_API_URL;

        this.$http.post(apiUrl + "/action/gz", {data: data, t: t}
        ).then((response) => {
          // console.log(response);
          if (response.body.status === 1) {
            this.$toast.center((type === 1 ? '关注' : '取关') + '成功！');
            this.gzLock = false;
            this.getData();
          } else {
            this.$toast.center((type === 1 ? '关注' : '取关') + '失败！');
            this.gzLock = false;
          }
        }).catch((e) => {
          this.gzLock = false;
          this.$toast.center((type === 1 ? '关注' : '取关') + '异常！请稍候重试或者联系工作人员！');
        })
        this.gzLock = false;
      }
    },
    dz: function (type) {
      if (!this.countAction()) {
        this.$toast.center('操作过于频繁，请稍候重试！');
        return;
      }
      if (this.dzLock) {
        return;
      }
      this.dzLock = true;
      if (this.userId == undefined || this.userId == '') {
        this.dzLock = false;
        this.zhangh();
      } else if (this.noteId != null && this.noteId.length > 0) {
        this.dzStatus = type === 1 ? 1 : 0;
        this.totalLike = this.totalLike + (type === 1 ? 1 : -1);
        let params = {"userId": this.userId, "uuid": this.uuid, "noteId": this.noteId, "type": type}
        let t = new Date().getTime();
        let data = this.common.encodeParams(params, t);
        let apiUrl = process.env.APP_API_URL;

        this.$http.post(apiUrl + "/action/dz", {data: data, t: t}
        ).then((response) => {
          // console.log(response);
          if (response.body.status === 1) {
            // this.getTempData();
          } else {
            this.$toast.center('服务器忙，请稍候重试！');
          }
          this.dzLock = false;
        }).catch((e) => {
          this.$toast.center('服务异常！请稍候重试或者联系工作人员！');
          this.dzLock = false;
        })
      }
      this.dzLock = false;
    },
    collect: function (type) {
      if (!this.countAction()) {
        this.$toast.center('操作过于频繁，请稍候重试！');
        return;
      }
      if (this.collectLock) {
        return;
      }
      this.collectLock = true;
      if (this.userId == undefined || this.userId == '') {
        this.collectLock = false;
        this.zhangh();
      } else if (this.noteId != null && this.noteId.length > 0) {
        this.collectStatus = type === 1 ? 1 : 0;
        this.totalCollect = this.totalCollect + (type === 1 ? 1 : -1);
        let params = {"userId": this.userId, "uuid": this.uuid, "noteId": this.noteId, "type": type}
        let t = new Date().getTime();
        let data = this.common.encodeParams(params, t);
        let apiUrl = process.env.APP_API_URL;

        this.$http.post(apiUrl + "/action/collect", {data: data, t: t}
        ).then((response) => {
          // console.log(response);
          if (response.body.status === 1) {
            this.$toast.center((type === 1 ? '收藏成功' : '收藏已取消'));
            // this.getTempData();
          } else {
            this.$toast.center((type === 1 ? '收藏' : '取消') + '失败！');
          }
          this.collectLock = false;
        }).catch((e) => {
          this.collectLock = false;
          this.$toast.center((type === 1 ? '收藏' : '取消') + '异常！请稍候重试或者联系工作人员！');
        })
      }
      this.collectLock = false;
    },
    comment: function () {
      if (this.userId == undefined || this.userId == '') {
        this.zhangh();
      } else {
        this.drawer = true;
        this.$nextTick(function () {
          $("#input_comment_div").find("textarea").trigger("click").focus();
        })
        $("body").animate({scrollTop: $(document).height()}, 800);
      }
    },
    replyComment: function (commentId, replyId, replyName, senderId) {
      if (this.userId != undefined && this.userId !== '') {
        if (senderId === this.userId) {
          this.select_drawer = true;
          this.replyCommentId = commentId;
          this.replyId = replyId;
          this.sendInputHolder = "回复:" + replyName;
        } else {
          this.showSenderInput(commentId, replyId, replyName);
        }

      }
    },
    showSenderInputForLi: function () {
      this.drawer = true;
      this.select_drawer = false;
      this.$nextTick(function () {
        $("#input_comment_div").find("textarea").trigger("click").focus();
      })
      $("body").animate({scrollTop: $(document).height()}, 800);
    },
    delComment: function () {
      if (this.replyCommentId != null && this.replyCommentId.length > 0 ||
          (this.replyId != null && this.replyId.length > 0)) {
        this.select_drawer = false;
        let commentId = this.replyId;
        if (!commentId) {
          commentId = -1;
        }
        let params = {
          "userId": this.userId,
          "uuid": this.uuid,
          "noteId": this.noteId,
          "commentId": commentId <= 0 ? this.replyCommentId : commentId,
        }
        let t = new Date().getTime();
        let data = this.common.encodeParams(params, t);
        let apiUrl = process.env.APP_API_URL;


        this.$http.post(apiUrl + "/action/del_c", {data: data, t: t}
        ).then((response) => {
          // console.log(response);
          if (response.body.status === 1) {
            this.getData();
            this.sendComment = "";
            this.replyCommentId = "";
            this.replyId = "";
            this.sendInputHolder = "说点什么...";
            this.$toast.center('删除成功！');
          } else {
            this.$toast.center('服务器忙！请稍候重试！');
          }
          this.sendLock = false;
        }).catch((e) => {
          this.sendLock = false;
          this.$toast.center('服务异常！请稍候重试或者联系工作人员！');
        })
        this.sendLock = false;
      }
    },
    showSenderInput: function (commentId, replyId, replyName) {
      this.drawer = true;
      this.replyCommentId = commentId;
      this.replyId = replyId;
      this.sendInputHolder = "回复:" + replyName;
      this.$nextTick(function () {
        $("#input_comment_div").find("textarea").trigger("click").focus();
      })
      $("body").animate({scrollTop: $(document).height()}, 800);
    },
    send: function () {
      if (!this.countAction()) {
        this.$toast.center('操作过于频繁，请稍候重试！');
        return;
      }
      if (this.sendLock) {
        return;
      }
      this.sendLock = true;
      if (this.sendComment != null && this.sendComment.length > 0) {
        let params = {
          "userId": this.userId,
          "uuid": this.uuid,
          "noteId": this.noteId,
          "comment": this.sendComment,
          "commentId": this.replyCommentId == null ? -1 : this.replyCommentId,
          "replyId": this.replyId == null ? -1 : this.replyId,
        }
        let t = new Date().getTime();
        let data = this.common.encodeParams(params, t);
        let apiUrl = process.env.APP_API_URL;


        this.$http.post(apiUrl + "/action/comment", {data: data, t: t}
        ).then((response) => {
          // console.log(response);
          if (response.body.status === 1) {
            this.getData();
            this.drawer = false;
            this.sendComment = "";
            this.replyCommentId = "";
            this.replyId = "";
            this.sendInputHolder = "说点什么...";

          } else if (response.body.status === -2) {
            this.$toast.center('评论中有敏感词语，请调整后重试！');
          } else if (response.body.status === -3) {
            this.$toast.center('服务器忙，请稍候重试！');
          } else {
            this.$toast.center('评论失败！请稍候重试！');
          }
          this.sendLock = false;
        }).catch((e) => {
          this.sendLock = false;
          this.$toast.center('评论异常！请稍候重试或者联系工作人员！');
        })
        this.sendLock = false;
      }
    },
    commentDz: function (commentId, type, item, p_index) {
      if (!this.countAction()) {
        this.$toast.center('操作过于频繁，请稍候重试！');
        return;
      }
      if (this.commentDzLock) {
        return;
      }

      if (this.userId == undefined || this.userId == '') {
        this.commentDzLock = false;
        this.zhangh();
      } else if (this.noteId != null && this.noteId.length > 0) {

        item.currentUserLike = type === 1 ? 1 : 0;
        item.totalLike = item.totalLike + (type === 1 ? 1 : -1);
        this.$set(this.commentList, p_index, item);


        let params = {
          "userId": this.userId,
          "uuid": this.uuid,
          "noteId": this.noteId,
          "commentId": commentId,
          "type": type
        }
        let t = new Date().getTime();
        let data = this.common.encodeParams(params, t);
        let apiUrl = process.env.APP_API_URL;


        this.$http.post(apiUrl + "/action/c_dz", {data: data, t: t}
        ).then((response) => {
          // console.log(response);
          if (response.body.status === 1) {
            // this.getTempData();
          }
          this.commentDzLock = false;
        }).catch((e) => {
          this.commentDzLock = false;
          this.$toast.center('服务异常！请稍候重试或者联系工作人员！');
        })
        this.commentDzLock = false;
      }
    },
    subCommentDz: function (commentId, type, item, p_index, subItem, index) {
      if (!this.countAction()) {
        this.$toast.center('操作过于频繁，请稍候重试！');
        return;
      }
      if (this.commentDzLock) {
        return;
      }

      if (this.userId == undefined || this.userId == '') {
        this.commentDzLock = false;
        this.zhangh();
      } else if (this.noteId != null && this.noteId.length > 0) {

        subItem.currentUserLike = type === 1 ? 1 : 0;
        subItem.totalLike = subItem.totalLike + (type === 1 ? 1 : -1);
        item.subCommentList[index] = subItem;
        this.$set(this.commentList, p_index, item);

        let params = {
          "userId": this.userId,
          "uuid": this.uuid,
          "noteId": this.noteId,
          "commentId": commentId,
          "type": type
        }
        let t = new Date().getTime();
        let data = this.common.encodeParams(params, t);
        let apiUrl = process.env.APP_API_URL;

        this.$http.post(apiUrl + "/action/c_dz", {data: data, t: t}
        ).then((response) => {
          // console.log(response);
          if (response.body.status === 1) {
            // this.getTempData();
          }
          this.commentDzLock = false;
        }).catch((e) => {
          this.commentDzLock = false;
          this.$toast.center('服务异常！请稍候重试或者联系工作人员！');
        })
        this.commentDzLock = false;
      }
    },
    adClose: function () {
      this.img_id_new = this.img_id_new + 1;
      // console.log(this.img_id_new);
      $("#e_b_div_115").html('');
      this.maskShow = false;
      this.load(2);
    },
    toLeft: function (a) {
      // console.log(a);

      var coos = localStorage.getItem("book_login");

      if (coos == undefined) {
        if (a >= 2) {
          $('.banner').attr('style', 'filter:blur(6px);');
          $("#mask").css("display", "block");
          $("#header").css("z-index", "0");
          $("#show1").css("display", "block");
        }
      } else {
        if (a == this.toti) {
          //滑到最后面弹窗显示广告
          this.loadBanner(115);
          this.loadBanner(150);
          this.loadBanner(148);
          $("body").animate({
            scrollTop: "0px"
          })
          $("#mask1").css("display", "block");
          $("#mask11").css("display", "block");
          $("#show2").css("display", "block");
          $("body").css("overflow", "hidden");
          $("#container").css("overflow", "hidden");
          $("#nav").css("z-index", "10000");
          $('.banner').attr('style', 'filter:blur(6px);');

          //现在没有广告直接下一组，有广告时就不要了
          // this.load(1);
        } else {
          this.current = this.timer[a].tim;
        }
      }

    },
    toReft: function (b) {
      if (b > 1) {
        // console.log(b);
        this.current = this.timer[b - 2].tim;
      }

    },
    cancel: function () {
      $("#mask").css("display", "none");
      $("#mask1").css("display", "none");
      $("#mask11").css("display", "none");
      $("body").css("overflow", "auto");
      $("#show2").css("display", "none");
      $("#show1").css("display", "none");
      $("#shb").css("z-index", "999");
      this.load(1);
      // $('body,html').attr("style","overflow:auto");
    },
    loadBanner: function (id) {

      let e_b_ts_1 = new Date().getTime();
      let ad = document.createElement("script");
      ad.src = "https://api.qvpublish.com/imp.js?id=" + id + "&ts=" + e_b_ts_1 + "&tp=async";
      ad.id = "e_b_sc_" + id;
      ad.type = "text/javascript";
      if (id == 115) {
        let section1 = document.getElementById("fou-gg1");
        if (section1) {
          section1.appendChild(ad);
        }
      } else if (id == 148) {
        let section2 = document.getElementById("fou-gg2");
        if (section2) {
          section2.appendChild(ad);
        }
      } else if (id == 150) {
        let section3 = document.getElementById("fou-gg3");
        if (section3) {
          section3.appendChild(ad);
        }
      }
    },
    handleClose(done) {
      this.sendComment = "";
      this.replyCommentId = "";
      this.replyId = "";
      this.sendInputHolder = "说点什么...";
      done();
    },
    goBack:function(){
      Cookies.remove('book_huoqu');
      let path = this.common.encodePath("BeautyDetail");
      this.$router.push({name: 'BeautyList', query: {src: path, id: this.a}});
      // this.$router.push({path:'/meizhuang'});
    }
  },
  mounted: function () {
    this.getCookie();
    // this.userTool.setUserLastPage(document.URL);
    this.userTool.setUserLastRouter(this.name);
    this.load(0);
    this.slideBanner();

    if(this.common.srcFromWeather()){
      this.fromWeather = true;
    }else{
      this.fromWeather = false;
    }
    var _hmt = _hmt || [];
    var hm = document.createElement("script");
    if(this.fromWeather){
      hm.src = "https://hm.baidu.com/hm.js?da9815d6b4a5d97e58c2156c9b3060cf";
    }else{
      hm.src = "https://hm.baidu.com/hm.js?3e969611694dba0a7e1be8513c061efb";
    }
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);


    new Swiper('.swiper-container', {
      loop: false,
      // 如果需要分页器
      pagination: '.swiper-pagination',
      observer: true,
      observeParents: false
    })

    //阻止左右滑动，不阻止上下

    var startPos = 0, endPos = 0, isScrolling = 0;

    document.addEventListener('touchstart', function (event) {

      var touch = event.targetTouches[0]; //touches数组对象获得屏幕上所有的touch，取第一个touch

      startPos = {x: touch.pageX, y: touch.pageY, time: +new Date}; //取第一个touch的坐标值

      isScrolling = 0; //这个参数判断是垂直滚动还是水平滚动

    }, false);

    //解绑事件 web前端开发

    document.addEventListener('touchend', function (event) {

      document.removeEventListener('touchmove', this, false);

      document.removeEventListener('touchend', this, false);

    }, false);

    document.addEventListener('touchmove', function (event) {
      // event.preventDefault();
      if (event.targetTouches.length > 1 || event.scale && event.scale !== 1) return;

      var touch = event.targetTouches[0];

      endPos = {x: touch.pageX - startPos.x, y: touch.pageY - startPos.y};

      isScrolling = Math.abs(endPos.x) < Math.abs(endPos.y) ? 1 : 0; //isScrolling为1时，表示纵向滑动，0为横向滑动

      if (isScrolling === 0) {

        event.preventDefault(); //阻止触摸事件的默认行为，即阻止滚屏

      }
    }, {
      passive: false
    });

  },
  activated:function (){
    console.log("detail:activated");
  },
  deactivated:function (){
    console.log("detail:deactivated");
  }
}
</script>

<style scoped>
/*//隐藏掉鼠标悬浮出现的左右切换按钮*/
::v-deep .el-carousel__arrow {
  display: none;
}

/*// 圆点样式*/
/deep/ .home-banner .el-carousel__indicator--horizontal .el-carousel__button {
  width: .06rem;
  height: .06rem;
  background: transparent;
  background: #e5e5e5;
  border-radius: 50%;
  opacity: 1;
}

/deep/ .el-carousel{
  margin-top: -0.15rem;
}
/deep/ .home-banner .el-carousel__indicator--horizontal.is-active .el-carousel__button {
  width: 6px;
  height: 6px;
  background: #c41010;
  border-radius: 50%;
  opacity: 1;
}
/deep/ .send_comment_button .el-button--mini span {
  color: white;
}
#gz_span {
  color: #ff2442;
}

#ygz_span {
  color: grey;
}
.swiper-container {
  width: 100%;
  /* margin: 20px auto; */
}

img {
  pointer-events: none;
}

#shb {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 999;
}

#header {
  /* width: 100%; */
  padding: 0 .16rem;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#header h4 {
  font-weight: bold;
  color: #ba1515;
  line-height: .52rem;
  /* margin-left: .12rem; */
}

#header h3 {
  font-weight: bold;
  color: #ba1515;
  font-size: .14rem;
  line-height: .52rem;
  margin-right: .12rem;
}

#header h3 span {
  font-weight: bold;
  color: #ba1515;
  font-size: .14rem;
  line-height: .52rem;
}

#nav {
  width: 100%;
  /* height: 1.1rem; */
}

#nav1 {
  width: 100%;
  /* height: .28rem; */
  z-index: 99999;
  position: fixed;
}

#container {
  /* margin: 0 .1rem; */
  margin-top: .45rem;
}

#container div img {
  width: 100%;

}

#e_b_div_1 img {
  height: .4rem;
}

.shuom {
  line-height: .36rem;
  font-size: .13rem;
}

#mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  background: rgba(66, 66, 66, 0.6);
  text-align: center;
}

#ad-banner {
  width: 2.6rem;
  height: 3rem;
  background: #fff;
  border-radius: .06rem;
  margin: 0 auto;
  margin-top: 2rem;
}

.banner {
  width: 100%;
  height: 100%;
}

#ad-x {
  width: 90%;
  height: 90%;
  border: 1px solid #aaa;
  border-radius: .15rem;
}

#ad-div {
  width: .2rem;
  height: .2rem;
  margin: 0 auto;
  margin-top: .12rem;
  text-align: center;
  line-height: .2rem;
}

.null {
  width: 100%;
  height: 1.1rem;
}

img {
  width: 100%;
}

.tishi {
  width: 2.4rem;
  height: .4rem;
  background: #fff;
  position: fixed;
  left: .52rem;
  bottom: .2rem;
  border-radius: .04rem;
  display: flex;
  justify-content: space-around;
  padding: .06rem;
}

/* #logo{
  width: .6rem;
}
#logo img{
  width: 100%;
  height: 100%;
} */
#goind {
  width: .15rem;
  height: .15rem;
  background: url(../../static/img/back2.png) no-repeat;
  background-size: 100%;
}

#tomin {
  width: .2rem;
  height: .2rem;
  background: url(../../static/img/my_icon.png) no-repeat;
  background-size: 100%;
}

#mask {
  position: fixed;
  top: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background: rgba(97, 97, 97, 0.9);
  display: none;
  overflow-y: auto;

}

#mask1 {
  position: fixed;
  top: 1.4rem;
  z-index: 9;
  width: 100%;
  height: 100%;
  background: rgba(97, 97, 97, 0);
  display: none;
}

#mask11 {
  position: fixed;
  top: 2rem;
  z-index: 9;
  width: 100%;
  height: 62%;
  background: rgba(66, 66, 66, 0.96);
  display: none;
}

.cuo {
  padding: 0 .08rem;
  text-align: end;
}

#show1 {
  display: none;
  margin: 0 auto;
  position: relative;
  top: 50%; /*偏移*/
  margin-top: -.8rem;
}

#show2 {
  position: fixed;
  top: 2.1rem;
  width: 100%;
  display: none;
}

#show3 {
  width: 2.8rem;
  height: 2.4rem;
  background: #fff;
  margin: 0 auto;
  border-radius: .03rem;
  position: relative;
  top: 50%; /*偏移*/
  margin-top: -1.2rem;
  display: none;
}

#show4 {
  width: 2.8rem;
  height: 2.7rem;
  background: #fff;
  border-radius: .03rem;
  display: none;
  margin: 0 auto;
  position: relative;
  top: 50%; /*偏移*/
  margin-top: -1.35rem;
}

#show5 {
  width: 2.8rem;
  height: 3.6rem;
  background: #fff;
  border-radius: .03rem;
  display: none;
  margin: 0 auto;
  position: relative;
  top: 50%; /*偏移*/
  margin-top: -1.8rem;
}

#content_login {
  padding: .1rem;
}

#content_rgist {
  padding: .1rem;
}

.cont {
  width: 100%;
  height: .36rem;
  line-height: .36rem;
  display: flex;
  justify-content: space-around;
  border: 1px solid #efeeee;
  color: #53575a;
}

input::placeholder {
  color: #999999;
}

.cont-d {
  width: .6rem;
  text-align: justify;
  text-justify: distribute-all-lines; /*ie6-8*/
  text-align-last: justify; /* ie9*/
  -moz-text-align-last: justify; /*ff*/
  -webkit-text-align-last: justify; /*chrome 20+*/
  font-size: .15rem;
}

@media screen and (-webkit-min-device-pixel-ratio: 0) {
  /* chrome*/
  .cont-d:after {
    content: ".";
    display: inline-block;
    width: 100%;
    overflow: hidden;
    height: 0;
  }
}

#login {
  width: 100%;
  height: .36rem;
  text-align: center;
  margin: .2rem auto;
  line-height: .36rem;
  color: #fff;
  background: #ba1515;
  border-radius: .04rem;
  font-size: .13rem;
  margin-bottom: 0;
}

#meiyou {
  margin-top: .12rem;
  font-size: .131rem;
  color: #163bc5;
  text-align: center;
}

#fou-gg1 {
  margin-top: .1rem;
}

.fou-gg, #e_b_div_1 {
  width: 100%;
  height: 1.2rem;
  /* background: url(../../static/img/247.png) no-repeat; */
  /* background-size: 100%; */
}

#lock {

  margin-bottom: 0.2rem;
  width: .4rem;
  height: .4rem;
}

#biglove {
  width: 1rem;
  height: 1rem;
  background: url(../../static/img/shixin.png) no-repeat;
  background-size: 100%;
  position: fixed;
  top: 3rem;
  z-index: 9;
  left: 1.4rem;
}

.days_btn1 {
  display: none;
}

.days_btn {
  display: block;
}

.notScroll {
  overflow: hidden;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}

.carousel-indicator {
  position: relative;
  top: 0.3rem;
  z-index: 9;
  left: 3rem;
  margin-top: .1rem;
  width: .35rem;
  text-align: center;
  line-height: .22rem;
  border-radius: .1rem;
  color: #fff;
  font-size: .1rem;
  background: rgba(0, 0, 0, .5);
}

.author-follow.b-button.s {
  /*width: 0.5rem;*/
  height: 0.25rem;
  position: relative;
  margin-left: 1rem;
}

.b-button .color {
  color: #ff2442;
}

.b-button.s {
  height: 26PX;
  padding: 0 10PX;
}

.b-button {
  font-weight: 500;
  font-size: 13PX;
}

.b-button {
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  white-space: nowrap;
  outline: none;
  background: none;
  border: none;
  position: relative;
  z-index: 0;
  vertical-align: middle;
  text-align: center;
  display: inline-block;
  border-radius: 1000PX;
}

.b-button-outline {
  border: 1px solid;
  border-radius: inherit;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  color: #ff2442;
}

.b-button-text {
  color: #ff2442;
}

.title {
  margin-left: 0.1rem;
  padding-top: 0.1rem;
  line-height: .3rem;
  font-size: .18rem;
  font-weight: 500;
}

.content {
  font-size: .16rem;
  line-height: .25rem;
  white-space: pre-line;
  margin-left: .1rem;
  margin-right: .1rem;
}

.publish {
  font-size: .11rem;
  line-height: .2rem;
  margin-left: .1rem;
  margin-top: .1rem;
  color: #999;
}

.action-input {
  max-width: 1.3rem;
  padding-left: .05rem;
  height: .3rem;
  line-height: .3rem;
  font-size: .15rem;
  border-radius: 1000PX;
  background: #f5f5f5;
  border: none;
  flex: 1;
  display: flex;
  align-items: center;
  position: relative;
  margin-left: .1rem;
  margin-top: .1rem;

}

.action-text {
  max-width: 1.3rem;
  padding-left: .05rem;
  /*height: .3rem;*/
  /*line-height: .15rem;*/
  font-size: .15rem;
  border-radius: 1000PX;
  /*background: #f5f5f5;*/
  border: none;
  flex: 1;
  display: flex;
  align-items: center;
  position: relative;
  margin-left: .1rem;
  margin-top: .04rem;

}

.barrage-txt {
  color: #999;
  font-size: .12rem;
  vertical-align: middle;
}

.action-buttons {
  position: relative;
  display: flex;
  align-items: center;
  margin-left: .38rem;
}

.action-button {
  margin-left: .1rem;
  font-size: .16rem;
}

.action-bar {
  display: flex;
  align-items: center;
  height: .4rem;
}

.action-input {
  margin-bottom: .1rem;
}

.line_01 {
  height: 0.001rem;
  background-color: #e7e4e4;
  margin-top: .1rem;
  width: 94%;
  margin-left: 3%;
}

.comment {
  margin-top: .1rem;
}

.total_comment {
  font-size: .12rem;
  color: #6b6a6a;
  margin-left: .1rem;
}

.comment_main {
  display: flex;
  justify-content: flex-start;
}

.comment_head_image {
  margin-left: .1rem;
  margin-top: .15rem;
}

.comment_txt {
  margin-left: .1rem;
  width: 2.7rem;
}

.comment_nickname {
  color: #8e8e8e;
  font-size: .15rem;
  margin-top: .1rem;
}

.comment_content {
  font-size: .14rem;
  margin-right: .1rem;
}

.comment_xin {
  margin-top: .07rem;
}

.comment_xin_image {
  /*margin-top:.1rem;*/
}

.comment_xin_num {
  /*margin-left: .05rem;*/
  font-size: .1rem;
  color: #9D9D9D;
  text-align: center;
}

.comment_sub_head_image {
  margin-left: .5rem;
  margin-top: .15rem;
}

.comment_sub_txt {
  margin-left: .1rem;
  width: 2.4rem;
  margin-top: .1rem;
}

.comment_sub {
  display: flex;
  justify-content: flex-start;
}

.comment_sub_nickname {
  color: #8e8e8e;
  font-size: .14rem;
  /*margin-top: .05rem;*/
}

.comment_sub_content {
  font-size: .12rem;
  margin-right: .1rem;
}

.comment_sub_xin {
  margin-top: .07rem;
}

.comment_sub_xin_image {
  /*margin-top:.1rem;*/
}

.comment_sub_xin_num {
  /*margin-left: .05rem;*/
  font-size: .1rem;
  color: #9D9D9D;
  text-align: center;
}

.authorItem {
  margin-top: .03rem;
  /*margin-right: .1rem;*/
  /*font-size: .1rem;*/
}

.rf-n {
  font-size: .14rem;
}

.line_02 {
  height: 0.01rem;
  background-color: #e7e4e4;
  margin-top: .1rem;
  width: 85%;
  margin-left: 12%;
}

.comment_more {
  font-size: .13rem;
  margin-top: .06rem;
  margin-left: .86rem;
  color: #1861b1;
}

.common_time {
  color: #8e8e8e;
  font-size: .1rem;
  white-space: nowrap;
}

/deep/ .el-badge__content--info {
  background-color: #e5e6ea;
  color: #8e8e8e;
}


#user {
  width: .2rem;
  height: .2rem;
  background-size: 100%;
  border-radius: .2rem;
  overflow:hidden;
}

#user img {
  vertical-align: initial;
}

/deep/ .el-icon-star-on {
  color: #FFE600;
  font-size: .20rem;
}

/deep/ .el-drawer__body {
  overflow: auto;
}

/deep/ .el-drawer__container ::-webkit-scrollbar {
  display: none;
}

.select-opt-ul {
  list-style: none;
  margin: 0;
  padding: 0;
  padding-top: 4px;
  background-color: #e0e0e0;
}

.select-opt-ul li {
  background-color: #e0e0e0;
  border-bottom: .01rem solid #c8c6c6;
}

#foot {
  width: 100%;
  /*height: 1rem;*/
  background: #ba1515;
  color: white;
  font-size: .12rem;
  /* margin: 0 .12rem; */
  margin-left: -.1rem;
  text-align: center;
  padding: .1rem 0;
  line-height: .22rem;
}
</style>



// WEBPACK FOOTER //
// src/view/BeautyDetail.vue